export default class AlFontSelectorController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.translate = this.injector.get('$translate');
        this.acl = this.injector.get('Acl');
        this.timeout = this.injector.get('$timeout');

        this.editEnabled = true;
        this.showExtendedSettings = false;
        this.selectValues = {
            families: [],
            sizes: _.transform(_.range(5, 50), (res, value, key) => {
                res.push({
                    label: value,
                    value
                });
            }),
            weights: [],
            decorations: [],
            transformations: [],
            styles: []
        };

        this.disabled = false;
        this.availableFonts = [];
        this.currentConfig = {};
        this.currentUpdateIndex = 0;
        this.onConfigChange = () => {
        };

        this.configModel = {
            family: null,
            size: 10,
            weight: 400,
            transformation: 'none',
            decoration: 'none',
            style: 'normal'
        };

        this.uniqueContainerIdentifier = this.scope.$id;
    }

    $onInit() {
        this.configModel = {
            ...this.configModel,
            ...(this.currentConfig || {})
        };

        this._initWatchers();
        this._checkIfEditEnabled();
        this._prepareAvailableSelections();
    }

    updateConfigModelValue(field, newValue) {
        _.set(this.configModel, field, newValue);
        this.scope.$applyAsync();
    }

    _prepareAvailableSelections() {
        let selectValues = {
            ...this.selectValues,
            families: _.map(
                this.availableFonts,
                (font) => {
                    return {
                        label: font.label,
                        value: font.key
                    }
                }
            )
        };

        let newFontToSet = _.cloneDeep(this.configModel.family);
        // Check if current selected font is valid
        if (_.filter(selectValues.families, (font) => (font.value === newFontToSet)).length === 0) {
            newFontToSet = _.get(_.first(selectValues.families), 'value', null);
        }

        if (!_.isNull(newFontToSet)) {
            const activeFont = _.first(_.filter(this.availableFonts, (font) => font.key === newFontToSet));
            if (activeFont) {
                selectValues = {
                    ...selectValues,
                    transformations: _.map(activeFont.transformations, (transformation) => ({
                        value: transformation,
                        label: transformation
                    })),
                    weights: _.map(activeFont.weights, (weight) => ({
                        value: weight,
                        label: weight
                    })),
                    decorations: _.map(activeFont.decorations, (decoration) => ({
                        value: decoration,
                        label: decoration
                    })),
                    styles: _.map(activeFont.styles, (style) => ({
                        value: style,
                        label: style
                    }))
                }
            }
        }

        this.selectValues = selectValues;
        this.configModel.family = newFontToSet;

        this._triggerUpdate();
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.availableFonts,
            (newVal, oldVal) => {
                this._checkIfEditEnabled();
                this._prepareAvailableSelections();
            },
            true
        )
        this.scope.$watch(
            () => this.configModel.family,
            (newVal, oldVal) => {
                this._prepareAvailableSelections()
            },
            true
        )

        this.scope.$watch(
            () => this.configModel,
            (newVal, oldVal) => {
                this._triggerUpdate()
            },
            true
        )

        this.scope.$watch(
            () => this.disabled,
            () => {
                this._checkIfEditEnabled();
            }
        )

        this.scope.$watch(
            () => this.currentConfig,
            (newVal) => {
                if (this.configModel && !_.isEqual(this.configModel, newVal)) {
                    this.configModel = _.cloneDeep(newVal);
                }
            }
        )
    }

    _checkIfEditEnabled() {
        this.editEnabled = !this.disabled && this.availableFonts.length > 0;
    }

    _triggerUpdate() {
        this.onConfigChange({
            value: _.cloneDeep(this.configModel)
        })
    }
}

AlFontSelectorController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-font-selector/controller.js